import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CasellaPunteggio from '../components/CasellaPunteggio';
import { GithubPicker, ColorResult } from 'react-color';
import { Popover, OverlayTrigger } from 'react-bootstrap';

import { SquadraTabella as Squadra, SquadraInSessione } from '../api/types';
import './RigaPunteggi.scss'

interface IProps {
  squadra: Squadra,
  nome: string,
  posizione: number,
  evidenzia: boolean,
  dettagli_squadra: SquadraInSessione,
  mostra_scuola: boolean,
  polo_info?: boolean,
  rowRef?: (node: HTMLTableRowElement | null) => void,
}

interface ColoriParams {
  [squadra_name: string]: ColorResult,
}


const getColoreStart: (squadra: Squadra, colori: ColoriParams) => ColorResult | null = (squadra, colori) => {
  const colore_squadra = (colori != null) ? colori[squadra.nome] : null;
  return (colore_squadra == undefined) ? null : colore_squadra
}

const getColori: (l: ReturnType<typeof useLocation>) => ColoriParams = (location) => {
  const base = location.hash.split("?");
  if (base.length != 2) return {};
  const colori_param = (new URLSearchParams(base[1])).get("colori")
  if (!colori_param) return {};
  const decoded = atob(colori_param);
  return JSON.parse(decodeURIComponent(decoded))
}

const encodeColori = (topush: ColoriParams): string => {
  const encoded = btoa(JSON.stringify(topush));
  return new URLSearchParams({ colori: encoded }).toString()
}

const newUrl: (location: ReturnType<typeof useLocation>, colori: string) => string = (location, colori) => {
  const base = location.hash.split("?")[0];
  return location.pathname + (base.length == 0 ? "#" : base) + "?" + colori;
}


const Penalita = (props: { dettagli_squadra: SquadraInSessione | null }) => {
  const val = props.dettagli_squadra?.penalita;

  if (!val || val == 0) {
    return null;
  }
  const color = val > 0 ? "success" : "danger";
  const direction = val > 0 ? "up" : "down";


  return (
    <span className={`text-${color}`}>
      <div className={`badge badge-pill badge-${color} mr-2`} title="Penalità">
        <i className={`fa fa-angle-double-${direction} fa-xs`} />
      </div>
      {val}
    </span>
  )
}


const RigaPunteggi = (props: IProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const colori = getColori(location);
  const [color, setColor] = useState(getColoreStart(props.squadra, colori))


  const resetColor = () => {
    const nuovicolori = getColori(location);
    let newpath = "";
    if (nuovicolori != null) {
      delete nuovicolori[props.squadra.nome];
      newpath = (Object.keys(colori).length === 0) ? "" : encodeColori(nuovicolori);
    }
    navigate(newUrl(location, newpath), { replace: true })
    setColor(null);
  }

  const handleChangeComplete = (color: ColorResult) => {
    setColor(color)

    let old = getColori(location);
    let topush = { [props.squadra.nome]: color };
    let colori = encodeColori(Object.assign({}, old, topush));
    navigate(newUrl(location, colori))
  }

  let colorpicker = (
    <Popover title="Evidenzia con un colore" id="color-picker">
      <GithubPicker
        onChangeComplete={handleChangeComplete}
        triangle="hide"
      />
      <div className="row justify-content-center">
        <button className="btn btn-warning" onClick={resetColor}>Reset</button>
      </div>
    </Popover >
  );



  const penalita = <Penalita dettagli_squadra={props.dettagli_squadra} />;
  let extra_props = color ? { "bgcolor": color.hex } : null;
  const polo_extra = props.polo_info !== undefined ? (props.polo_info ?
    <span className="badge badge-info ml-2" title="Squadra non del polo corrente">
      Polo
    </span>
    : null) : null;

  return (
    <>
      <OverlayTrigger trigger="click" placement="top" overlay={colorpicker} rootClose>
        <tr data-toggle="tooltip"
          data-placement="top" title="Premi per scegliere un colore"
          {...extra_props}
          ref={props.rowRef}
        >
          <td>{props.posizione}</td>
          <td>
            {props.nome} {penalita}
            {props.evidenzia && <i className="fa fa-circle text-success" />}
            {polo_extra}
            {props.mostra_scuola && <><br className="rigapunteggi" /> <small>{props.dettagli_squadra?.scuola.nome}, {props.dettagli_squadra?.scuola.indirizzo?.citta.name}</small></>}
          </td>
          <td>{props.squadra.totale}</td>
          {props.squadra.problemi.map(
            (pti, idx) => <CasellaPunteggio key={idx} dettagli={pti} />)
          }
        </tr>
      </OverlayTrigger>
    </>
  );
}

export default RigaPunteggi;
